import pino from "pino";

export function initLogger(moduleName: string) {
  const pinoLogger = pino({
    name: moduleName,
    level: process.env.PINO_LOG_LEVEL || "info",
  });
  return pinoLogger;
}
